import React from "react";
import {Outlet} from "react-router-dom";
import MainMenu from "./main-menu";
import "./layout.scss";

const Layout = () => {
  return (
    <>
      <MainMenu />
      <Outlet />
    </>
  );
};

export default Layout;
